import { configureStore } from '@reduxjs/toolkit';  
import rootReducer from './reducers';  
  
const DEFAULT_STATE = {  
  error: { message: null },  
  user: {},  
};  
  
export const store = configureStore({  
  reducer: rootReducer,  
  preloadedState: DEFAULT_STATE,  
});  
